import styled from 'styled-components';
import COLORS from '../../utils/Colors';

interface MarkerProps {
    lat: number;
    lng: number;
}

export const Container = styled.div`
    height: 100vh;
    width: 100%;
    background-color: ${COLORS.freshaWhite};
`;

export const Section = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 5rem;
`;

export const Title = styled.p`
    font-size: 1em;
    font-weight: 500;
    color: ${COLORS.freshaBlack};
    margin-right: 1rem;
`;

export const Option = styled.p`
    font-size: 1em;
    color: ${COLORS.freshaBlack};
`;

export const BusinessMarkerContainer = styled.div<MarkerProps>`
    display: flex;
    position: absolute;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1;

    &:hover {
        z-index: 2
    };

    & img {
        width: 50px;
        height: 50px;
    }
`;

export const Marker = styled.div`
    background-color: ${COLORS.freshaBlack};
    border: none;
    color: ${COLORS.freshaWhite};
    border-radius: 50px;
    height: 3em;
    width: 7em;
    justify-content: center;
    align-items: center;
    display: flex;
    font-weight: 500;
`;

